import React from "react";
import {
  Box,
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useRef } from "react";
import { styled } from "@mui/system";
import Footer from "../components/Footer/PrelaunchFooter/Footer";
import Navbar from "../components/Navbar/Navbar";


const FooterContainer = styled(Box)({
  backgroundColor: "#FFFFFF",
  padding: "40px 0 40px",
  textAlign: "center",
});

const steps = [
  "Go to the Profile tab.",
  "Tap 'View Profile' to access your account details.",
  "Scroll down and tap 'Delete Account'.",
  "Confirm deletion when prompted. Deleted data includes Profile Information and Saved Addresses.",
  "Tap confirm again to permanently delete your account and data.",
];

const AccountDeactivation = () => {
  const aboutUsRef = useRef(null);
  const ourProcessRef = useRef(null);
  const manufactureRef = useRef(null);
  const ingredientsRef = useRef(null);
  return (
    <div>
      <div style={{ backgroundColor: "#f5f5f5" }}>
        <Navbar
          aboutUsRef={aboutUsRef}
          ourProcessRef={ourProcessRef}
          manufactureRef={manufactureRef}
          ingredientsRef={ingredientsRef}
        />
      </div>
      <Container
        maxWidth="xs"
        sx={{
          background: "#f7f9f9",
          textAlign: "center",
          marginTop: "10px",
          padding: "15px",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 500, color: "#014C35" }}>
          Account Deactivation Steps
        </Typography>
        <Box sx={{ padding: "0px" }}>
          <List>
            {steps.map((step, index) => (
              <ListItem key={index} sx={{ justifyContent: "center" }}>
                <ListItemText
                  primary={`Step ${index + 1}: ${step}`}
                  sx={{
                    color: "#014C35",
                    textAlign: "left",
                    fontWeight: 400,
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default AccountDeactivation;
